import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    button: {
        width: '100%',
        height: '100%',
        padding: '7px',
        fontSize: '0.9285714285714285rem',
        color: '#202124 !important',
        border: '1px solid #cdd5d8 !important',
        display: 'block',
        flexGrow: 4,
        boxSizing: 'border-box',
        flexBasis: '80px',
        textAlign: 'left',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 500,
        lineHeight: 1.75,
        borderRadius: '4px !important',
        textTransform: 'uppercase',
        transition: 'var(--transitn)',
    },
    regular: {
        "&:hover": {
            border: '1px solid var(--clr_grey) !important',
        }
    },
    more: {
        display: 'flex',
        flexFlow: 'row wrap',
        textAlign: 'left',
        padding: '2px 3px',
        justifyContent: 'space-around',
        alignItems: 'center',
        flex: '0 1 26px',
        '& span': {
            width: 2,
            height: 2,
            background: 'var(--clr_grey)',
            borderRadius: '50%',
            transition: 'var(--transitn)',
            margin: 1
        }
    },
    row: {
        flexdirection: 'row',
        display: 'flex',
        justifyContent: 'flex-start',
        columnGap: '4px',
        borderRadius: '0 !important',
        "&:not(:first-child)": {
            borderTop: 'none !important',
        },
        '&:first-child': {
            borderRadius: '4px 4px 0 0 !important',
        },
        '&:last-child': {
            borderRadius: '0 0 4px 4px !important',
        },
        "& div": {
            fontWeight: 'normal',
        },
        '&:hover': {
            background: 'var(--clr_subwhite) !important',
        },
    }
}))

export default useStyles;
